module.exports = __webpack_public_path__ + "img/1997_L.7f03d12e.png";